import { useNavigate } from 'react-router-dom';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import ENSLogo from '../assets/images/logos/ens-logo-dark.png';
import ThreeSixtyCustomsLogo from '../assets/images/360customs-green-logo.jpg';
import ThreeSixtyBanner from '../assets/images/360pay-banner.jpg';
import Button from '@mui/material/Button';
import { ShowIf } from '../components/Security/security';

import HomeImage1 from '../assets/images/home1.png';
import HomeImage2 from '../assets/images/home2.png';
import HomeImage3 from '../assets/images/home3.png';

const boxStyles = {
  sectionContainer: { padding: '0 0px' },
  section: { display: 'flex', marginBottom: '30px', padding: '40px' },
  image: { width: '50%', textAlign: 'center' },
  title: { width: '50%', justifyContent: 'center', alignItems: 'center', display: 'flex' },
};

export default function LandingPage() {
  const navigate = useNavigate();
  const navigateToRegister = () => {
    navigate('./register');
  };

  return (
    <Container className="landing-page-container" maxWidth="lg" sx={{ marginBottom: 5 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 10 }}>
        <Box>
          <img src={ENSLogo} alt="ENS Logo" height={80} />
        </Box>
        <Box>
          <img src={ThreeSixtyCustomsLogo} alt="360Customs Logo" height={60} />
        </Box>
      </Box>
      <Box sx={{ marginTop: 5 }}>
        <img src={ThreeSixtyBanner} alt="360Pay Banner" style={{ maxWidth: '100%' }} />
      </Box>
      <Box sx={{ maxWidth: 650, textAlign: 'center', paddingTop: 5, paddingBottom: 15, margin: '0 auto' }}>
        <h1>Safety and Security GB</h1>
        <p style={{ fontSize: 18 }}>
          CABIE S&S GB is a free to use service for EU to GB Roll On Roll Off movement of goods that require an GB Entry
          Security Declaration.
        </p>
        <ShowIf isLoggedIn={false}>
          <Box sx={{ marginTop: 5 }}>
            <Button className="home-signup-button" onClick={navigateToRegister}>
              Sign Up
            </Button>
          </Box>
        </ShowIf>
      </Box>

      <Box sx={boxStyles.sectionContainer}>
        <Box sx={boxStyles.section}>
          <Box sx={boxStyles.image}>
            <img src={HomeImage1} alt="Self Service" style={{ maxWidth: '100%' }} />
          </Box>
          <Box sx={boxStyles.title}>
            <h2>Self Service</h2>
          </Box>
        </Box>

        <Box sx={boxStyles.section}>
          <Box sx={boxStyles.title}>
            <h2>Quick and Easy</h2>
          </Box>
          <Box sx={boxStyles.image}>
            <img src={HomeImage2} alt="Quick and Easy" style={{ maxWidth: '100%' }} />
          </Box>
        </Box>

        <Box sx={boxStyles.section}>
          <Box sx={boxStyles.image}>
            <img src={HomeImage3} alt="Free to use" style={{ maxWidth: '100%' }} />
          </Box>
          <Box sx={boxStyles.title}>
            <h2>Free to use</h2>
          </Box>
        </Box>

        <Box sx={{ ...boxStyles.section, marginTop: 10, marginBottom: 15 }}>
          <Box sx={boxStyles.image}>
            <a href="#" onClick={navigateToRegister} className="lets-go-button">
              Let's Go
            </a>
          </Box>
          <Box sx={boxStyles.title}>
            <p className="signup-text">Sign up to start your S&amp;S GB declarations</p>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
